define(
    'sandbox',[
        'loader',
        'config',
        '../core/Transport.js',
        '../core/Storage.js',
        '../core/Sound.js'
    ],
    function(Loader, Config, Transport, Storage, Sound)
    {
        var _ = Loader._;
        var _subscribe = function(channel, callback)
        {
            Transport.subscribe(channel, callback);
        };

        var _send = function(channel, data, successCallback, errorCallback, silent)
        {
            Transport.send(channel, data, successCallback, errorCallback, silent)
        };

        var _set = function(key, value)
        {
            Storage.set(key, value);
        };

        var _get = function(key)
        {
            return Storage.get(key);
        };

        var _remove = function(key)
        {
            Storage.remove(key);
        };

        var sandbox = _.extend(
            {
                transport:
                {
                    subscribe: _subscribe,
                    send: _send,
                    rpc: Transport.rpc,
                    io: {
                        initialize: Transport.io.initialize,
                        send: Transport.io.send,
                        subscribe: Transport.io.subscribe,
                        reconnect: Transport.io.reconnect
                    }
                },

                storage:
                {
                    set: _set,
                    get: _get,
                    remove: _remove
                },

                sound:
                {
                    play: Sound.play,
                    stop: Sound.stop
                }
            },
            Loader.Backbone.Events
        );

        return sandbox;
    }
);
